import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../../environments/environment';
import { Observable, throwError } from 'rxjs';
import { MoveTaskFilesToFileGroupRequestInterface } from './definitions/move-task-files-to-file-group-request.interface';
import { catchError } from 'rxjs/operators';
import { handleProblem } from '../../problems/problem.service';

@Injectable()
export class MoveTaskFilesToFileGroupService {

  private apiUrl: string = environment.rest.apiV2Url;

  constructor(private httpClient: HttpClient) {}

  public moveFiles(
    taskId: string,
    targetTaskFileGroupId: string | null,
    request: MoveTaskFilesToFileGroupRequestInterface
  ): Observable<any> {
    const url = this.buildUrl(taskId, targetTaskFileGroupId);

    return this.httpClient.post(url, request).pipe(
      catchError(error => throwError(handleProblem(error)))
    );
  }

  private buildUrl(taskId: string, targetTaskFileGroupId: string | null): string {
    const baseUrl = this.apiUrl;
    
    return targetTaskFileGroupId === null
        ? `${baseUrl}/partner/tasks/${taskId}/task-file-groups/files/remove`
        : `${baseUrl}/partner/tasks/${taskId}/task-file-groups/${targetTaskFileGroupId}/files/move`;
  }
}
